const CATEGORY_NAMES_EN = {
  'максим': 'Maxim gun',
  'станок': 'Gun mount',
  'ЗИП': 'Spares & accessories',
  'другое': 'Other',
};

// IDs are used deliberately: several records share the same Russian name,
// while their English labels need to be different (for example, "другое").
const DETAIL_TYPE_NAMES_EN = {
  1: 'Trail',
  2: 'Skids',
  3: 'Connecting-yoke bolt',
  4: 'Spacer',
  5: 'Wheels',
  6: 'Main axle',
  7: 'Main-axle nut',
  8: 'Split nut',
  17: 'Other mount parts',
  18: 'Water jacket',
  22: 'Connecting yoke',
  23: 'Table',
  24: 'Locking device',
  25: 'Clamp',
  26: 'Swivel',
  27: 'Fine traverse mechanism',
  28: 'Coarse traverse mechanism',
  30: 'Other Maxim gun parts',
  31: 'Other items',
  32: 'Legs',
  33: 'Recoil spring cover',
  34: 'Front sight',
  35: 'Crank handle (frame)',
  37: 'Trail locking mechanism',
  39: 'Small-parts box',
  40: 'Feed block',
  41: 'Seat wheel',
  42: 'Level',
  43: 'Lock base',
  44: 'Shield reel',
  45: 'Trigger bar',
  46: 'Left slide',
  47: 'Rear sight',
  48: 'Ammunition-belt box',
  49: 'Backplate',
  50: 'Top cover',
  51: 'Traverse scale',
  52: 'Belt-loading machine',
  53: 'Grip tassels',
  54: 'Muzzle booster',
  55: 'Screwdriver',
  56: 'Connecting bolt',
  57: 'Fine traverse latch',
};

const DETAIL_SUBTYPE_NAMES_EN = {
  1: 'Steel ribbed hubs',
  2: 'Bronze six-rib hubs',
  3: 'Triangular, 1920s pattern',
  4: 'Wooden',
  5: 'Tinplate',
  6: 'Lugged pattern',
  7: 'Bronze',
  8: 'Folding',
  9: 'Fixed',
  10: 'Telescopic',
  11: 'Imperial, riveted',
  12: 'Imperial steel, Model 1910',
  13: 'Bronze, Model 1910',
  14: 'Bronze, Model 1910 — flat top',
  15: 'Leningrad siege production',
  16: 'Bronze, early Soviet',
  17: 'Late, simplified and rounded',
  18: 'Early, sprung, with hook',
  19: 'Model 1910 — steel anchor',
  20: 'Without windage adjustment',
  21: 'Early Imperial — slender post',
  22: 'Late Imperial — thick post',
  23: 'Model 1905',
  24: 'Five positions, slotted',
  25: 'Bronze, with holes',
  26: 'Three holes, late Imperial',
  27: 'Three holes, standard',
  28: 'Full-length slot',
  29: 'Early wooden',
  30: 'Pre-war / wartime — steel',
  31: 'Bronze four-rib hubs',
  32: 'Silumin — flat, without button',
  33: 'Silumin — standard, without button',
  34: 'Silumin — flat, with button',
  35: 'Bronze',
  36: 'External bronze screw',
  37: 'External steel screw',
  38: 'Late Imperial',
  39: 'Late pattern',
  40: 'Early, with fin',
  41: 'Early, corkscrew-shaped',
  42: 'Early, flip-over',
};

const MANUFACTURER_NAMES_EN = {
  1: 'ORZ',
  2: 'TOZ',
  3: 'DWM',
  4: 'Izhevsk',
  5: 'Factory No. 66, evacuated to Zlatoust',
  7: 'Factory No. 535 (Tula)',
  8: 'Factory No. 66 (Tula, 1939–1941)',
  9: 'VSM',
  10: 'Bryansk Arsenal',
  11: 'SOZ (Voskova)',
  12: 'SHTAMP',
  13: 'ЖсРн/Д',
  14: 'PF',
};

function localiseById(item, translations, lang) {
  if (!item) return '';
  if (lang !== 'EN') return item.name || '';
  return translations[item.id] || item.name || '';
}

export function localiseCategoryName(value, lang) {
  if (!value || lang !== 'EN') return value || '';
  return CATEGORY_NAMES_EN[value] || value;
}

export function localiseDetailTypeName(type, lang) {
  return localiseById(type, DETAIL_TYPE_NAMES_EN, lang);
}

export function localiseDetailSubtypeName(subtype, lang) {
  return localiseById(subtype, DETAIL_SUBTYPE_NAMES_EN, lang);
}

export function localiseManufacturerName(manufacturer, lang) {
  return localiseById(manufacturer, MANUFACTURER_NAMES_EN, lang);
}
